import Cookie from 'cookie-universal'
import { logger } from '@cred/fe-logger'
import config from 'config'
import events from './events'
import { browserCookies, utmValidator } from './utils'
import { attribution } from './contexts'

const cookieOptions = { path: '/' },
  eventMap = {}

Object.keys(events).forEach(key => {
  eventMap[events[key].getSchema()] = events[key]
})

/*eslint-disable */
const
/* eslint-enable */
  _setUserId = () => {
    // Get user's UUID from cookies and set it to Snowplow
    const
      cookies = Cookie(),
      uuid = cookies.get('user_id', cookieOptions)

    window.snowplow('setUserId', uuid)
  },

  /**
   * @param options (optional)
   */
  initialize = ({ cookieDomain, customSPCollectorUri, allowCrossDomainTracking } = {}) => {
    if (!global.window || global.window.snowplow) {
      return false
    }

    const { isSnowplowV3, env, snowplowEndpoint, snowplowAppId, snowplowEncodeBase64 = false } = config || {}
    const collectorUrl = env === 'production' ? 'analytics.credible.com' : 'analytics-qa.credible.com'
    const jsUrl = isSnowplowV3 ? '//cdn.jsdelivr.net/npm/@snowplow/javascript-tracker@3.23.0/dist/sp.min.js' : '//cdn.jsdelivr.net/gh/snowplow/sp-js-assets@2.16.1/sp.js'

    try {
      // Snowplow starts plowing
      (function(p, l, o, w, i, n, g) {
        if (!p[i]) {
          p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
          p.GlobalSnowplowNamespace.push(i);p[i] = function() {
            (p[i].q = p[i].q || []).push(arguments)
          };p[i].q = p[i].q || [];n = l.createElement(o);g = l.getElementsByTagName(o)[0];n.async = 1
          n.src = w;g.parentNode.insertBefore(n, g)
        }
      }(window, document, 'script', jsUrl, 'snowplow'))

      window.snowplow('newTracker', 'default', customSPCollectorUri || snowplowEndpoint || collectorUrl, {
        appId: snowplowAppId,
        platform: 'web',
        encodeBase64: snowplowEncodeBase64,
        cookieDomain: cookieDomain || '.credible.com',
        contexts: {
          webPage: true,
          performanceTiming: true,
        },
        post: true
      })

      // @BohdanCredible: we need to store the domain user id to capture it in the Click UUID database https://credible.atlassian.net/browse/PELO-4458
      window.snowplow(function () {
        const cookies = Cookie()
        const expires = new Date(Date.now() + 30 * 864e+5)

        let sp = this.default
        let domainUserId = sp.getDomainUserId()
        
        cookies.set('domain_user_id', domainUserId, {
          path: '/',
          expires,
          secure: false,
          httpOnly: false
        })
      })

      if (allowCrossDomainTracking) {
        window.snowplow('crossDomainLinker', (linkElement) => {
          return /(^|^www\.|^(develop|uat|stage|dev\d{4})\.qa\.|^local\.)credible.com$/.test(linkElement.hostname)
        })
      }

      // Enable page pings
      // First ping after 30 seconds, then every 10 seconds

      if (isSnowplowV3) {
        window.snowplow('enableActivityTracking', {
          minimumVisitLength: 30,
          heartbeatDelay: 10
        })
      } else {
        window.snowplow('enableActivityTracking', 30, 10)
      }

      // Add attribution context to all events
      const { utm_source, utm_medium, utm_campaign, utm_content, utm_referrer, preferred_lender, blog_landing, blog_lastpage } = browserCookies()
      if (utm_source || utm_medium || utm_campaign || utm_content || preferred_lender || utm_referrer || blog_landing || blog_lastpage) {
        window.snowplow('addGlobalContexts', [
          attribution.analytics({
            source: utm_source,
            medium: utm_medium,
            campaign: utm_campaign,
            content: utm_content,
            preferredLender: utmValidator('preferred_lender', preferred_lender, 256),
            referrer: utmValidator('utm_referrer', utm_referrer, 2048),
            blogLanding: utmValidator('blog_landing', blog_landing, 2048),
            blogLastpage: utmValidator('blog_lastpage', blog_lastpage, 2048),
          })
        ])
      }
      _setUserId()
    } catch (e) {
      console.error('Snowplow initializing error: ', e)
    }
  },

  trackEvent = options => {
    if (!options || !options.event || !global.window) {
      return
    }

    const { isSnowplowV3 } = config || {}

    const {event, action, contexts} = options,
      snowplowEvent = eventMap[event.schema]


    if (isSnowplowV3) {
      if (snowplowEvent) {
        window.snowplow('trackSelfDescribingEvent', { event: snowplowEvent.build(event, action), context: contexts })
      } else if (event.schema) {
        window.snowplow('trackSelfDescribingEvent', { event, context: contexts })
      }
    } else {
      if (snowplowEvent) {
        window.snowplow('trackSelfDescribingEvent', snowplowEvent.build(event, action), contexts)
      } else if (event.schema) {
        window.snowplow('trackSelfDescribingEvent', event, contexts)
      }
    }
  },

  trackPageView = (pageTitle, contexts, options, shouldLogEvent = true) => {
    const { isSnowplowV3 } = config || {}

    if (!global.window) {
      return
    }

    _setUserId()

    try {
      let pageUrl = window.location.pathname

      if (options && options.pageUrl) {
        window.snowplow('setCustomUrl', options.pageUrl)
        options.referrerUrl && window.snowplow('setReferrerUrl', options.referrerUrl)
        pageUrl = options.pageUrl
      }

      if (isSnowplowV3) {
        window.snowplow('trackPageView', { 
          title: pageTitle || null,
          context: contexts || []
        })
      } else {
        window.snowplow('trackPageView', pageTitle || null, contexts || null)
      }

      const contextsWithoutSchema = contexts.reduce((acc, context) => {
        const { schema, ...rest } = context
        return [...acc, rest]
      }, [])

      if (shouldLogEvent) {
        logger.info('pageview', {
          pageUrl,
          pageTitle,
          contexts: contextsWithoutSchema
        }, `Snowplow pageview: ${pageUrl} ${pageTitle ? pageTitle : ''}`)
      }
    } catch (e) {
      console.error('Snowplow track page view error: ', e)
    }
  }

export {
  initialize,
  trackEvent,
  trackPageView
}

export default {
  initialize,
  trackEvent,
  trackPageView
}
